import React from "react";
import { Link } from "react-router-dom";
import { FaUtensils, FaCheckCircle } from "react-icons/fa";
import menuData from "./MenuData";
import { useHistory } from "react-router-dom";

const MenuCategories = () => {

  const history = useHistory();
  return (
    <div className="container my-5 ">
        <img alt="shape" className="menu_animation1" src="assets/img/shape/ctaShape1_3.png"></img>
         {/* <img src="assets/img/shape/popularDishesShape1_1.png" alt="shape" /> */}
      <div className="row">
        {menuData.map((menu) => (
          <div className="col-md-4 mb-4" key={menu.id}>
            
            <div className="card h-100 menu-card position-relative">

              {/* BADGE */}
              <span className={`menu-badge badge-${menu.badgeType}`}>{menu.badge}</span>

              <div className="card-body d-flex flex-column text-center">

                {/* MENU ICON */}
                <div className="menu-icon mb-3">
                  <FaUtensils size={30} />
                </div>

                {/* TITLE */}
                <h5 className="menu-title">
                  {menu.title}
                </h5>

                {/* DESCRIPTION */}
                <p className="menu-desc">
                  {menu.description}
                </p>

                {/* META */}
                <p className="menu-meta">
                  <FaCheckCircle className="me-1" />
                  {menu.items.length } Items
                </p>
              <div className="price">
                <p className="menu-price">
                  Starting at ₹{menu.prices?.[1000]} 
                  {/* / person */}
                </p>

                {/* BUTTON */}
                <Link
                  to={`/menu/${menu.id}`}
                  className="btn menu-btn mt-auto"
                >
                  View Menu
                </Link>
                </div>

              </div>
            </div>
          </div>

        ))}
      </div>

      
          <div style={{ textAlign: "center", marginTop: "0px" , left: "20px"}}>
            <button
              className="build-menu-btn"
              onClick={() => history.push("/build-menu")}
            >
              Build / Customize Your Menu
            </button>
         </div>
       <img alt="shape" className="menu_animation" src="assets/img/shape/foodmenuShape3_2.png"></img>
    </div>
  );
};

export default MenuCategories;
